import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import api from './http/api'
import './assets/scss/css.scss'
// mock
if (process.env.VUE_APP_MODE === 'mock') {
  require('./mock/index')
}

Vue.config.productionTip = false

Vue.prototype.$api = api

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
